interface IProcedures {
    setBalkon: (data: { balkon: string, montageart: string }) => void;
    setMontageart: (data: { balkon: string, montageart: string }) => void;
    setWandabstand: (wandabstand: string ) => void;
    setWidth: (value: number) => void;
    setDepth: (value: number) => void;
}


class Puzzles {
    public procedures: IProcedures | null = null;

    public setProcedures(procedures: never) {
        this.procedures = procedures;
    }
}

const puzzles = new Puzzles();
export default puzzles;
